import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {Observable, tap} from 'rxjs';
import {Account, Cashier} from '../_models/cashier.model';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private readonly API_URL = `${environment.API_URL}/agencybanking`;
    private tokenKey: string = environment.TOKEN_KEY;
    private CASHIER_INFOS: string = environment.CASHIER_INFOS;
    constructor(
        private http: HttpClient,
        private router: Router
    ) {}

    login(credentials: Partial<{ email: string | null; password: string | null }>): Observable<any> {
        return this.http.post<any>(`${this.API_URL}/login`, credentials).pipe(
            tap((res: any) => {
                this.setSession(res.data);
            }),
        );
    }
    logout(data?:any): Observable<any> {
        return this.http.post<any>(`${this.API_URL}/logout`,data).pipe(
            tap((res: any) => {
                localStorage.removeItem(this.tokenKey);
                localStorage.removeItem(this.CASHIER_INFOS);
                this.router.navigate(['/auth']);
            }),
        );

    }

    getAgencyAccount():Account{
        return <Account>this.getUserInfos()?.agency.account
    }
    removeLoginData(){
        localStorage.removeItem(this.tokenKey);
        localStorage.removeItem(this.CASHIER_INFOS);
        this.router.navigate(['/auth']);
    }
    getUserInfos():Cashier|null{
        const user = localStorage.getItem(this.CASHIER_INFOS);
        if (!user) {
            this.logout()
            return null
        }
        return JSON.parse(user);
    }
    private setSession(auth: { cashier:Cashier,token:string }): void {
        localStorage.setItem(this.tokenKey, auth.token);
        localStorage.setItem(this.CASHIER_INFOS, JSON.stringify(auth.cashier));
        // const userInfo = { email, role, userId, firstName, lastName };
        // localStorage.setItem(this.currentUser, JSON.stringify(userInfo));
        // this.currentUserSubject.next(auth.email);
    }

    getAgentLogo(){
        return (this.getUserInfos()?.agency?.agent?.logo) ? environment.API_URL + this.getUserInfos()?.agency?.agent?.logo : environment.API_URL + '/assets/images/logo-blue-icon.png'
    }

    getAgentPrimaryColor():string{
        return this.getUserInfos()?.agency.agent.color??'#1C75BC'
    }
    setAgentColors(): void {
        const primaryColor = this.getUserInfos()?.agency.agent.color??'#1C75BC'
        const secondaryColor = this.getUserInfos()?.agency.agent.secondaryColor
        const rgb = this.hexToRgb(primaryColor);
        if (rgb) {
            document.documentElement.style.setProperty('--user-color-primary', `${rgb.r}, ${rgb.g}, ${rgb.b}`);
        }
    }

    getAgentSecondaryColor():string{
        return this.getUserInfos()?.agency.agent.secondaryColor??'#1C75BC'
    }
    private hexToRgb(hex: string): { r: number; g: number; b: number } | null {
        const cleanedHex = hex.replace('#', '');
        if (cleanedHex.length !== 6) return null;
        const r = parseInt(cleanedHex.substring(0, 2), 16);
        const g = parseInt(cleanedHex.substring(2, 4), 16);
        const b = parseInt(cleanedHex.substring(4, 6), 16);
        return { r, g, b };
    }

    getTokenKey(){
        return   localStorage.getItem(environment.TOKEN_KEY);
    }
    isAuthenticated(){
        const token = this.getTokenKey();
        let authenticated:boolean=false
        if (token)
            return true
        return authenticated
    }
}
